export const rolesEmoji = {
    super: "🦸‍♀️",
    administrator: "👨‍💻",
    support: "👷‍♀️",
    customer: "💆‍♀️",
    basic: "👩‍💼",
    tenant_beta_lite: "👨‍💻",
    tenant_beta_full: "👨‍💻"
};
